import React, { useEffect, useMemo, useState } from "react";
import useBooleanState from "@clave/use-boolean-state";
import { AuctionItemStatus } from "../../auctions-list-page/contracts";
import styles from "./auctionLots.module.scss";
import BidModule from "./BidModule";
import BidWatched from "./BidWatched";
import config from "../../utils/config";
import Spinner from "../../common/Spinner";
import DOMPurify from "dompurify";
export default function AuctionLot({ strings, bidItem, auctionUrl, auctionStatus, onWatchedAdd, onWatchedRemove, saveItemPositionState, onBuyNow, showOnlyActive, forceShowWatchItem = false, biddingDisabled, }) {
    const [hideBid, setHideBid] = useBooleanState();
    const [item, setItem] = useState(bidItem);
    const [isMainImageLoading, setIsMainImageLoading] = useState(true);
    const imageUrl = useMemo(() => `${config.auctionItemsImagesRootUrl}/img/${bidItem.id}/${bidItem.mainImageFileId}?size=sm`, [bidItem]);
    const itemUrl = useMemo(() => {
        return `${auctionUrl}${bidItem.relativeUrl}`;
    }, [bidItem]);
    const categoryName = useMemo(() => {
        var _a, _b;
        return (_b = (_a = bidItem.lowestCategoryName) !== null && _a !== void 0 ? _a : bidItem.mainCategoryName) !== null && _b !== void 0 ? _b : strings.archiveCategoryName;
    }, [strings, bidItem]);
    useEffect(() => {
        // if auction should show only active lots and status was changed to SOLD (5, 7 or 9), hide that lot
        const isActiveItem = item.status == AuctionItemStatus.Sold
            || item.status == AuctionItemStatus.SoldConfirmed
            || item.status == AuctionItemStatus.Completed;
        setHideBid(isActiveItem && showOnlyActive);
    }, [item]);
    const onItemChanged = (item) => {
        setItem(item);
    };
    return (React.createElement("div", { id: item.id.toString(), className: `${styles.auctionLot} ${hideBid ? styles.movedBid : ""}` },
        React.createElement("a", { onClick: () => saveItemPositionState(bidItem.id), className: styles.imageContainer, href: itemUrl, title: item.number.toString() },
            React.createElement(React.Fragment, null,
                isMainImageLoading && React.createElement(Spinner, { size: "mini", position: "absolute-center" }),
                React.createElement("img", { src: imageUrl, loading: "lazy", alt: `${strings.objectNr} ${item.number}`, onLoad: () => setIsMainImageLoading(false) }))),
        React.createElement("a", { onClick: () => saveItemPositionState(item.id), className: styles.textContent, href: itemUrl, title: item.number.toString() },
            React.createElement("h2", null,
                strings.objectNr,
                ": ",
                item.number,
                " ",
                React.createElement("br", null),
                " ",
                React.createElement("em", null,
                    " ",
                    categoryName,
                    " ")),
            React.createElement("p", null, DOMPurify.sanitize(item.description, { ALLOWED_TAGS: [], ALLOWED_ATTR: [] })),
            bidItem.condition && (React.createElement("small", null,
                strings.condition,
                ": ",
                bidItem.condition))),
        (forceShowWatchItem || item.status == AuctionItemStatus.Available) && (React.createElement(BidWatched, { isWatched: item.isWatched, itemId: item.id, saveItemPositionState: saveItemPositionState, onAdd: onWatchedAdd, onRemove: onWatchedRemove })),
        React.createElement(BidModule, { bidItem: item, strings: strings, onBuyNow: onBuyNow, onItemChanged: onItemChanged, biddingDisabled: biddingDisabled, saveItemPositionState: saveItemPositionState, auctionStatus: auctionStatus })));
}
